var map = {
	"./atv.svg": "3f17",
	"./camping-pass.svg": "178f",
	"./canopy-night.svg": "e4cf",
	"./canopy.svg": "daf6",
	"./cottage.svg": "8469",
	"./day-pass.svg": "ee6f",
	"./horse-ride.svg": "5083",
	"./lake-village.svg": "cdf3",
	"./tepee.svg": "48a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db79";